import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    documentId: 0,
    attachments: []
  }
};
const docAttachmentsSlice = createSlice({
  name: "docAttachments",
  initialState,
  reducers: {
    loadAttachments: (state, action) => {
      state.value = {
        documentId: action.payload.documentId,
        attachments: action.payload.attachments
      };
    },
    updateAttachments: (state, action) => {
      state.value = {
        documentId: state.value.documentId,
        attachments: action.payload.attachments
      };
    }
  }
});
export const { loadAttachments, updateAttachments } = docAttachmentsSlice.actions;
export default docAttachmentsSlice.reducer;
